
import { DatePipe, CommonModule } from '@angular/common';
import { AfterViewChecked, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ActivatedRoute } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TimezoneDatePipe } from '../../../../timezone-date.pipe';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util.service';
import * as ExcelJS from 'exceljs';
import { NodataFoundComponent } from '../../../../widget/nodata-found/nodata-found.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-customer-billing',
  standalone: true,
  imports: [BsDropdownModule, CommonModule, FormsModule, NgxDatatableModule, MatTooltipModule, TimezoneDatePipe, NodataFoundComponent,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './customer-billing.component.html',
  styleUrls: ['./customer-billing.component.scss']
})
export class CustomerBillingComponent implements OnInit, AfterViewChecked, OnDestroy {
  @Input() page: string;
  listToShow$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  years: any = []
  date: any = []
  totalCount = 0;
  params: any = {
    size: 10,
    page: 0,
    totalCount: 0


  };
  public selected = [];
  formattedRemark: string = '';
  businessId: string = null;
  role:any
  plan:any
  userId=localStorage.getItem('userId');
  selectedYear: number | null = null;
  headerStyle = {
    font: { bold: true, color: { argb: '111' } }, // White text color
    alignment: { horizontal: 'center' },
    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '7a76cd' } },
};
  constructor(  private apiService: ApiService, private datePipe: DatePipe,private util: UtilService,private activatedRoute : ActivatedRoute,
    private renderer: Renderer2, private el: ElementRef,
  ) {
    this.activatedRoute.parent.data.subscribe(res => {
      this.plan=res.data.plan;
    });
   }
   ngOnInit(): void {
    this.plandetailsget();
    this.generateYears();
    this.selectedYear = new Date().getFullYear();  // Set year BEFORE calling API
    this.getbusinessIdAndLoadHistory();
  }



  async plandetailsget(){
    const userId = localStorage.getItem('userId');
    let planbenefits: any = await this.apiService.lamdaFunctionsget('findUserPlanBenefits/' + localStorage.getItem('userId'));
    if (planbenefits.data != undefined) {
       localStorage.setItem("membershipType", planbenefits.data.userPlanAndBenefits.membershipType);
    }
  }

  getbusinessIdAndLoadHistory(): void {
    const userId = localStorage.getItem('userId');
    this.apiService.query(`business/findUserRoleInBusiness/${userId}`).subscribe(
      (response: any) => {
        if (response.data) {
          this.businessId = response.data.businessData.businessId;
          this.role = response.data.role;
        }
        this.historyAPIcall(this.selectedYear);
      },
    );
  }


  ngOnDestroy(): void {
    if (this.bodyScrollUnlistener) {
      this.bodyScrollUnlistener();
    }
    if (this.resizeUnlistener) {
      this.resizeUnlistener();
    }
  }


  scrollSynced = false; // Flag to prevent multiple bindings
  bodyScrollUnlistener: () => void; // To store the unlistener for clean-up
  resizeUnlistener: () => void; // To store resize unlistener

  ngAfterViewChecked() {
    const dataTableBody = this.el.nativeElement.querySelector('.datatable-body');
    const dataTableHeader = this.el.nativeElement.querySelector('.datatable-header');

    if (!this.isFirefox()) {
      // If it's not Firefox, no need for custom scroll handling
      return;
    }

    if (dataTableBody && dataTableHeader && !this.scrollSynced) {
      // Clean up any previous listeners to avoid duplicates
      if (this.bodyScrollUnlistener) {
        this.bodyScrollUnlistener();
      }
      if (this.resizeUnlistener) {
        this.resizeUnlistener();
      }

      // Scroll listener to sync body and header scrolls
      this.bodyScrollUnlistener = this.renderer.listen(dataTableBody, 'scroll', this.throttle(() => {
        dataTableHeader.scrollLeft = dataTableBody.scrollLeft;
      }, 10)); // Throttle the scroll event to improve performance

      // Listener for window resize to ensure the header remains aligned
      this.resizeUnlistener = this.renderer.listen(window, 'resize', () => {
        dataTableHeader.scrollLeft = dataTableBody.scrollLeft;
      });

      this.scrollSynced = true; // Mark scroll syncing as done
    }
  }

  // Browser detection function to check if the browser is Firefox
  isFirefox(): boolean {
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  }


  throttle(fn: Function, wait: number) {
    let time = Date.now();
    return function () {
      if ((time + wait - Date.now()) < 0) {
        fn();
        time = Date.now();
      }
    };
  }

  billhistroy: any = [];
  async historyAPIcall(year) {
    this.util.startLoader();
    let response: any;
    let baseUrl = `planPurchaseHistory?userId=${this.userId}&page=${this.params.page}&size=10&year=${year}`;
    if (this.role === "SUPERADMIN") {
      baseUrl += `&entityId=${this.businessId}`;
    }
    response = await this.apiService.lamdaFunctionsget(baseUrl);
    if (response && response.code === "00000") {
      let networkData = response.data && response.data.history;
      this.billhistroy = response.data && response.data.history;
      response.data.history.forEach((ele, i) => {
        if (ele.remarks && ele.remarks.includes('-->')) {
          const message = ele.remarks.split('-->')[1].trim();
          networkData[i].formattedRemark = message;
       } else{
        if(ele.remarks){
          networkData[i].formattedRemark =ele.remarks;
        }else if(ele.paymentStatus=="FAILED"){
          networkData[i].formattedRemark = "Failed";
        }else  {
          networkData[i].formattedRemark = "Payment succeeded";
        }
       }

      });

      setTimeout(() => {
        if (networkData) {
          this.listToShow$.next([...networkData]);
        }
        if (this.params.page == 0) {
          this.params.totalCount = response.data?.totalCount;
          this.totalCount=response.data?.totalCount
        }
      }, 100);


    }

    this.util.stopLoader();
  }

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }
  nextPage(data: any) {

    this.params.page = data.offset;
    if (this.params.page == 0) {
      this.params.page = 0;
    }

    this. historyAPIcall(this.selectedYear);
  }
  getPaymentStatusColor(status: string): string {
    switch (status) {
      case 'CANCELLED':
        return 'red';
      case 'PENDING':
        return '#ffb606';
      case 'FAILED':
        return 'red';
      case 'COMPLETED':
        return 'green';
      default:
        return '';
    }
  }
  getPaymentStatusText(status: string): string {
    switch (status) {
      case 'CANCELLED':
        return 'Cancelled';
      case 'PENDING':
        return 'Pending';
      case 'FAILED':
        return 'Failed';
      case 'COMPLETED':
        return 'Successful';
      default:
        return '';
    }
  }
  async generateExcelFile() {
    let res: any;
    let baseUrl = `planPurchaseHistory?userId=${this.userId}&page=${this.params.page}&size=10&year=${this.selectedYear}`;
    if (this.role === "SUPERADMIN") {
      baseUrl += `&entityId=${this.businessId}`;
    }
    res = await this.apiService.lamdaFunctionsget(baseUrl);

    if (res != undefined && res.code == "00000") {
      this.billhistroy = res.data.history;
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Sheet1');
      const currentDate = new Date();

      const headerStyle = {
        font: { bold: true, color: { argb: '111' } },
        alignment: { horizontal: 'center' },
        fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: '7a76cd' } },
      };

      const dataStyle = {
        font: { Helvetica: true, color: { argb: '1111' } },
        alignment: { horizontal: 'center' },
      };

      worksheet.addRow(['S.No', 'Date', 'MembershipType', 'Billing Type',  'Transaction Status', 'Remarks','Invoice Id', 'Amount']);

      worksheet.getRow(1).eachCell((cell: any) => {
        cell.style = headerStyle;
      });
      res.data.history.forEach((item, i) => {
        const formattedDate = this.datePipe.transform(new Date(item.createdOn), 'MM/dd/yyyy');
        const subscriptionAmount = '$' + item.subcriptionAmount / 100
        const remarks = item.remarks ? item.remarks : "Payment succeeded"
        const status = item.paymentStatus == 'COMPLETED' ? 'Successful' : 'Failed'
        worksheet.addRow([i + 1, formattedDate, item.membershipType, item.billingType,
          status, remarks, item.invoiceId,subscriptionAmount]);
      });
      worksheet.getRows(2, res.data.history.length + 1).forEach((row) => {
        row.eachCell((cell: any) => {
          cell.style = dataStyle;
        });
      });

      worksheet.columns.forEach((column) => {
        let maxLength = 0;
        column.eachCell({ includeEmpty: true }, (cell) => {
          const length = String(cell.value).length;
          maxLength = Math.max(maxLength, length);
        });
        column.width = maxLength + 2;

      });
      workbook.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Billing.xlsx';
        a.click();
        window.URL.revokeObjectURL(url);
      });
    }
  }
  Refresh(){
     this.historyAPIcall(this.selectedYear);
  }
  @ViewChild('sortTable') table: any;
  onSort(event) {
    const currentPage = this.params.page;
    this.table.offset = currentPage;
}
  onYearChange() {

      let yearToSend = this.selectedYear !== null ? this.selectedYear : new Date().getFullYear();
      this.historyAPIcall(yearToSend);
  }
  generateYears() {
    this.years = [];
    this.date = [];
    for (let i = new Date().getFullYear(); i >= new Date().getFullYear() - 5; i--) {
      this.years.push(i);
    }
  }

  scalexPayment(item:any){
    const url = item?.stripePaymentLink;
    console.log('url',url);
    if(url){
      window.location.href = url;
    }
  }
}


